export const operationTypes = [
  {
    text: 'Trade',
    value: 'trade',
  },
  {
    text: 'Gift',
    value: 'gift',
  },
  {
    text: 'Manual',
    value: 'manual',
  },
  {
    text: 'Bonus',
    value: 'bonus',
  },
]
